import { Box, LinearProgress, Sheet, Tooltip, Typography } from "@mui/joy";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import { useProjects } from "../../redux/project/projectHooks";
import { Cover } from "../cover/cover";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { AppRouter } from "../../appRouter";
import { RouterConfig } from "../config/routerConfig";
import { Toolbar } from "../gigsDatagrid/gigsDatagrid";

/**
 *
 * @returns {ReactElement} ProjectsDatagrid page
 */
export function ProjectsDatagrid() {
  const { projects, isLoading } = useProjects();
  const navigate = useNavigate();

  return (
    <DataGridPremium
      slots={{
        toolbar: Toolbar,
      }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
        },
      }}
      pagination
      pageSizeOptions={[25]}
      loading={isLoading}
      rows={projects ?? []}
      onRowClick={(p) => {
        navigate(
          `${RouterConfig.projects}/${p.row.id}?sourceID=${p.row.sourceID}&sourceRecordID=${p.row.sourceRecordID}&id=${p.row.id}`
        );
      }}
      columns={[
        {
          field: "sourceID",
          headerName: "",
          width: 12,
          renderCell: (p) =>
            p.value !== 420 ? (
              <Tooltip
                arrow
                size="sm"
                sx={{ maxWidth: 150, textAlign: "center" }}
                variant="outlined"
                title="Thie item cannot be edited. It is controlled by an organization using Rhapsody."
              >
                <i className="fa-solid fa-lock"></i>
              </Tooltip>
            ) : (
              <Box />
            ),
        },
        {
          field: "coverURL",
          headerName: "Cover",
          width: 80,
          renderCell: (c) => {
            const project = c.row;
            return <Cover type="project" url={project.coverURL} />;
          },
        },
        { field: "name", headerName: "Name", width: 500 },
        {
          field: "date",
          headerName: "Date & Description",
          width: 300,
          renderCell: (c) => {
            const project = c.row;

            return (
              <Box>
                <Typography level="body2">
                  <b>{project?.dateDescription()}</b>
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Typography level="body3">
                    {project?.sessionTypeDescription()}
                  </Typography>
                </Box>
              </Box>
            );
          },
        },
        {
          field: "completion",
          headerName: "Completion",
          width: 200,
          renderCell: (c) => {
            const project = c.row;
            return (
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
              >
                <Typography level="body2">
                  {project.completedGigCount()}/{project.gigCount()}
                </Typography>
                <LinearProgress
                  thickness={6}
                  determinate
                  value={project.completion()}
                />
              </Box>
            );
          },
        },
      ]}
      initialState={{
        pinnedColumns: {
          right: ["completion"],
        },
        pagination: {
          paginationModel: {
            pageSize: 25,
          },
        },
      }}
    />
  );
}
